import serviceConstants from "./serviceConstants"

const appService = (
    process.env.NODE_ENV === 'development' ? require('./mock-services.js') : require('./services.js')
).default

export {
    serviceConstants,
    appService,
}